.tooltip {
  position: fixed;
  z-index: 900;
  align-content: center;
}

.right {
  transform: translateY(-50%);
}
